import FeedIncident from "components/files/feed/FeedIncident";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { Link } from "react-router-dom";
import { IconInput, SVG, ToolTipV2 } from "ui";

const Incidents = () => {
    const [filter, setFilter] = useState("");

    return (
        <FeedLayout pageTitle="incidents">
            <div className="moment-mark-page pb-40">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/trending">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Incidents</h1>

                    <div></div>
                </div>

                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <IconInput
                        value={filter}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setFilter(e.target.value)}
                        rounded
                        className="w-full"
                        style={{ marginBottom: 0 }}
                    />

                    <div className="dropdown is-hoverable is-spaced is-right is-neutral dropdown-trigger">
                        <div className="fab-wrapper is-share">
                            <div
                                className="small-fab share-fab modal-trigger cursor-pointer"
                                data-modal="share-modal"
                            >
                                {/* <i data-feather="link-2"></i> */}
                                <SVG svg="filter" size={24} />
                            </div>
                        </div>
                        <div className="dropdown-menu" role="menu">
                            <div className="dropdown-content">
                                <a href="#" className="dropdown-item">
                                    <div className="media d-flex flex-j-start flex-a-center gap-10">
                                        <SVG
                                            svg="sort"
                                            size={18}
                                            className="light-grey-svg"
                                        />
                                        <div className="media-content text-start">
                                            <h3>Sort by Recent</h3>
                                        </div>
                                    </div>
                                </a>

                                <a href="#" className="dropdown-item">
                                    <div className="media d-flex flex-j-start flex-a-center gap-10">
                                        <SVG
                                            svg="circle-map-pointer"
                                            size={18}
                                            className="light-grey-svg"
                                        />
                                        <div className="media-content text-start">
                                            <h3>Sort by Nearest to You</h3>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <Link to="/map">
                        <ToolTipV2 text="Map">
                            <SVG svg="map" size={18} />
                        </ToolTipV2>
                    </Link>
                </div>

                <FeedIncident />
                <FeedIncident />
                <FeedIncident />
                <FeedIncident />
            </div>
        </FeedLayout>
    );
};

export default Incidents;
